import { useSelector } from "react-redux";
import { selectedBMSRState, selectedRidersState } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { selectUniformCoverageRiders } from "../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";

export const useRidersForUniformCoverage = () => {
    const selectedRiders = useSelector(selectedRidersState) ?? [];
    const selectedBMSR = useSelector(selectedBMSRState);
    const selectUniformCoverageRidersState = useSelector(selectUniformCoverageRiders);

    // Rider ID 11 is BMS
    const amountBMS = selectedBMSR?.inputs?.[0]?.fAmount ?? 0;

    const isSelected = (id: number) => selectedRiders.some(r => r.id === id);

    // NON-FLEXIBLE RIDERS
    const staticRiders = [
        (isSelected(PROPOSAL_RIDERS.BMSR.productFor.GCI) || isSelected(PROPOSAL_RIDERS.BMSR.productFor.GYRT)) && {
            rider_id: isSelected(PROPOSAL_RIDERS.BMSR.productFor.GCI)
                ? Number(PROPOSAL_RIDERS.BMSR.productFor.GCI)
                : Number(PROPOSAL_RIDERS.BMSR.productFor.GYRT),
            amount: amountBMS,
        },
    ].filter(
        (rider): rider is { rider_id: number; amount: number } => Boolean(rider),
    );

    const staticRiderIds = staticRiders.map(rider => rider.rider_id);

    const dynamicRiders = selectedRiders
        .filter(rider => !staticRiderIds.includes(rider.id))
        .map(rider => {
            const matched = selectUniformCoverageRidersState?.find(
                r => r.id === rider.id
            );

            return {
                rider_id: rider.id,
                amount: matched?.rider.fAmount ?? 0,
            };
        });

    return [...dynamicRiders, ...staticRiders];
};